/* ==========================================================
   MUSSO — Simple Quantity Limit (per variant)
   SOLO CONTROLA VISUALMENTE EL INPUT (1–5)
========================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const MAX_QTY = 5;

  function enhanceQuantity(container) {
    if (!container || container.dataset.mussoLimit === "1") return;
    container.dataset.mussoLimit = "1";

    const input = container.querySelector(".quantity__input");
    const btnPlus = container.querySelector('button[name="plus"]');
    const btnMinus = container.querySelector('button[name="minus"]');

    if (!input) return;

    function clamp() {
      let v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > MAX_QTY) v = MAX_QTY;
      input.value = v;

      if (btnPlus) {
        const disable = v >= MAX_QTY;
        btnPlus.disabled = disable;
        btnPlus.classList.toggle("disabled", disable);
      }

      if (btnMinus) {
        const disable = v <= 1;
        btnMinus.disabled = disable;
        btnMinus.classList.toggle("disabled", disable);
      }
    }

    clamp();
    input.addEventListener("input", clamp);
    input.addEventListener("change", clamp);

    // Mensaje debajo del input
    let rules =
      container.closest(".product-form__quantity")?.querySelector(".quantity__rules") ||
      container.parentNode.querySelector(".quantity__rules");

    if (!rules) {
      rules = document.createElement("div");
      rules.className = "quantity__rules caption";
      container.parentNode.appendChild(rules);
    }

    if (!rules.querySelector(".max-limit-msg")) {
      rules.insertAdjacentHTML(
        "beforeend",
        `<small class="max-limit-msg" style="color:#444;font-size:14px;display:block;margin-top:6px;">
           Maximum order: ${MAX_QTY} units per variant
         </small>`
      );
    }
  }

  document.querySelectorAll("quantity-input").forEach(enhanceQuantity);

  // Reaplicar cuando Shopify actualiza el DOM
  new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;

        if (node.matches?.("quantity-input")) {
          enhanceQuantity(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll("quantity-input").forEach(enhanceQuantity);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});


/* ==========================================================
   MUSSO — Cart: Mensaje global estable (NO duplicar, NO mover)
========================================================== */

document.addEventListener("DOMContentLoaded", () => {
  if (!window.location.pathname.includes("/cart")) return;

  const LIMIT = 5;

  function insertMessage() {
    const cartForm  = document.querySelector('form[action="/cart"]');
    const cartTable = cartForm?.querySelector("table");

    if (!cartTable) return;

    // 1) BORRAR cualquier mensaje dentro de las rows
    document.querySelectorAll(".quantity__rules").forEach(e => e.remove());

    // 2) BORRAR mensaje global anterior
    document.querySelectorAll("#musso-cart-limit-msg").forEach(e => e.remove());

    // 3) Crear el mensaje global abajo
    const msg = document.createElement("div");
    msg.id = "musso-cart-limit-msg";
    msg.style.cssText = `
      margin: 16px 0 24px;
      padding: 12px 16px;
      background: #f6f6f6;
      border-radius: 15px;
      color: #333;
      font-size: 14px;
    `;
    msg.textContent = `Maximum order: ${LIMIT} units per variant`;

    cartTable.insertAdjacentElement("afterend", msg);
  }

  // Insertar una vez que el cart esté renderizado
  setTimeout(insertMessage, 350);

  // Shopify recarga el cart por AJAX → volver a aplicar el FIX
  const obs = new MutationObserver(() => {
    // evitar bucles → solo actuamos si reapareció un ".quantity__rules"
    if (document.querySelector(".quantity__rules") ||
        !document.querySelector("#musso-cart-limit-msg")) {
      insertMessage();
    }
  });

  obs.observe(document.body, { childList: true, subtree: true });
});